import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { SCHOOL_LAB_SETUP_UPDATE } from "../apiRoutes";

export interface UpdateLabSetupRequest {
  schoolId: string; // sent as parameter in URL by caller
  targetDate?: string;
  noOfWorkstations?: number;
  specialRequirements?: string;
  labSetupStatus?: string;
  comment?: string;
}

export interface UpdateLabSetupResponse {
  data: any;
}

export const useUpdateLabSetupMutation = ({ onSuccess, onError }: { onSuccess?: (data: UpdateLabSetupResponse) => void; onError?: (e: any) => void; } = {}) => {
  const queryClient = useQueryClient();

  return useMutation<UpdateLabSetupResponse, Error, UpdateLabSetupRequest>({
    mutationFn: async (payload) => {
      // API expects schoolId as URL param according to spec
      const { schoolId, ...body } = payload;
      const res = await axiosAuth.put<UpdateLabSetupResponse>(`${SCHOOL_LAB_SETUP_UPDATE}${schoolId}/`, body);
      return res.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["schoolLabSetup"] });
      onSuccess?.(data);
    },
    onError: (err) => onError?.(err),
  });
};
